@if (online() === true) {
  <div class="online" @fadeIn @fadeOut>
    <div class="text-xs text-white bg-neutral-900 rounded-md px-2.5 py-1.5 flex flex-row items-center">
      <app-spinner></app-spinner>
      Connection restored...
    </div>
  </div>
}
